import type { MachinePark } from '@indutrust/factory-model';

/**
 * Whether a machine-park mutation should dual-write a pending shared-catalog
 * entry (custom machine awaiting admin review, no catalog id yet).
 */
export function shouldSubmitPendingCatalog(
  payload: Pick<MachinePark, 'machine_catalog_id' | 'pending_catalog_review'>
): boolean {
  return (
    (payload.machine_catalog_id === null ||
      payload.machine_catalog_id === undefined) &&
    payload.pending_catalog_review === true
  );
}
